// extracted by mini-css-extract-plugin
export default {"general-layout-wrapper":"GeneralLayoutWrapper_general-layout-wrapper__x26m-"};